import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';
import Button from '../../components/Button/Button';
import LandingNav from '../../components/LandingPage/LandingNav/LandingNav';
import LandingHero from '../../components/LandingPage/LandingHero/LandingHero';
import LandingCTA from '../../components/LandingPage/LandingCTA/LandingCTA';
import LandingFooter from '../../components/LandingPage/LandingFooter/LandingFooter';
import AudienceSection from '../../components/LandingPage/AudienceSection/AudienceSection';
import LandingFAQ from '../../components/LandingPage/LandingFAQ/LandingFAQ';

// Import visuals
import visual01 from '../../image-assets/visual_01.png';
import visual02 from '../../image-assets/visual_02.png';
import visual03 from '../../image-assets/visual_03.png';
import visual04 from '../../image-assets/visual_04.png';

// Define features for each section - Concise Feature Descriptions
const writerFeatures = [
  { title: "Effortless Polishing", description: "Fix grammar, improve clarity, and ensure consistency automatically.", docsId: "tone-of-voice" },
  { title: "Perfect Tone, Every Time", description: "Adapt your writing tone for any audience, culture, or style.", docsId: "tone-of-voice" },
  { title: "Writing Assistant", description: "Get smart suggestions to rephrase, shorten, or expand text.", docsId: "ai-translate" }
];

const localizationFeatures = [
  { title: "Fast AI Translation", description: "Instantly translate unlimited strings using state-of-the-art AI.", docsId: "ai-translate" },
  { title: "Managed Reviews", description: "Collaborate on feedback and approvals for high-quality translations.", docsId: "reviews" },
  { title: "Broad Platform Support", description: "Export ready-to-use files for iOS, Android, Web, and other platforms.", docsId: "export" }
];

const developerFeatures = [
  { title: "Easy file Import/Export", description: "Easily import/export files like JSON, XML, .strings, and more.", docsId: "import" },
  { title: "API & Automation", description: "Automate translation workflows and integrate with your CI/CD pipeline.", docsId: "api" },
  { title: "Universal Placeholders", description: "Define platform-agnostic placeholders that export correctly everywhere.", docsId: "placeholders" }
];

const teamFeatures = [
  { title: "Team Collaboration", description: "Invite members, assign roles, and collaborate in real-time.", docsId: "collaboration" },
  { title: "Organized Workflow", description: "Track status, assign tasks, and manage localization deadlines.", docsId: "reviews" },
  { title: "Consistent Brand Voice", description: "Maintain consistent terminology and style across all languages.", docsId: "tone-of-voice" }
];

const LandingPage = () => {
  return (
    <div className="landing-page">
      <LandingNav />

      {/* Use LandingHero component */}
      <LandingHero />

      {/* Audience-focused Sections with IDs */}
      <AudienceSection
        id="writers"
        title="Effortless writing & editing"
        description="Fix grammar, refine tone, and polish your copy effortlessly. Let AI enhance your writing so every word matters."
        features={writerFeatures}
        visualContent={<img src={visual01} alt="Texta editor showing writing and editing features" />}
      />

      <AudienceSection
        id="localization"
        title="Accurate translation, no revisions"
        description="Get accurate AI translations quickly, then fine-tune your message. Manage all languages without the headache."
        features={localizationFeatures}
        visualContent={<img src={visual02} alt="Texta editor showing translation features" />}
      />

      <AudienceSection
        id="developers"
        title="Fits your development workflow"
        description="Import existing files, automate with the API, and forget platform-specific formatting."
        features={developerFeatures}
        visualContent={<img src={visual03} alt="Texta editor showing developer-friendly features like API and file export" />}
      />

       <AudienceSection
         id="teams"
         title="Collaborate effectively on content"
         description="Great copy is a team effort. Bring everyone together to manage projects and craft the perfect message, together."
         features={teamFeatures}
         visualContent={<img src={visual04} alt="Texta editor showing team collaboration features" />}
       />

      {/* Use LandingCTA component */}
      <LandingCTA />

      {/* Add LandingFAQ component */}
      <LandingFAQ />

      {/* Use LandingFooter component */}
      <LandingFooter />
    </div>
  );
};

export default LandingPage; 